<div class="container-not-same-email">
    <h3>{{ '$forbidden.notSameEmail' | translateAsync }}</h3>
</div>
